import React, { useState } from "react";
import AllPayments from "../../UI/SellerPayment/AllPayments";
import WithdrawalHistory from "../../UI/SellerPayment/WithdrawalHistory";
import { useNavigate } from "react-router-dom";

const SellerPayment = () => {
  const navigate = useNavigate();

  // const [paymentTab, setPaymenttab] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  const [activeTab, setActiveTab] = useState(0);
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const tabs = ["All Payments", "Withdrawal History"];

  const tabContent = [
    { panel: <AllPayments /> },
    { panel: <WithdrawalHistory /> },
  ];

  return (
    // <div className="w-full h-[1200px] flex items-center justify-center">
    <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col pt-[28px] pb-[35px] px-[33px]">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col">
          <h3 className="w-[107px] h-[24px] text-black text-start font-semibold text-[16px]">
            Payment
          </h3>
          <hr className="w-[164px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />
        </div>
        <div className="flex flex-row w-[329px] items-center justify-between">
          <button
            onClick={togglePopup}
            className="w-[165px] h-[41px] bg-[#FF6300] rounded-[5px] font-semibold text-[14px] text-white flex items-center justify-center"
          >
            Withdraw Amount
          </button>

          {isOpen && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="w-[831px] h-[392px] bg-white rounded-[10px] py-[33px] pl-[42px] pr-[72px] flex flex-col">
                <h2 className="flex justify-center font-semibold text-[16px] text-black">
                  Withdraw Amount
                </h2>
                <h3 className="w-[242px] h-[24px] text-black font-semibold text-[16px] mt-[38px]">
                  Available Balance : ₹ 1,00,000
                </h3>
                <form>
                  <div className="h-[79px] gap-y-[9px] w-full flex flex-col mt-[32px]">
                    <label className="block w-[96px] h-[21px] font-medium text-[14px] text-black">
                      Enter amount
                    </label>
                    <input
                      type="number"
                      id="number-input"
                      value={value}
                      onChange={handleChange}
                      className="w-[717px] h-[49px] border rounded-[5px] p-[12px] placeholder:w-[826px] placeholder:h-[95px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black"
                    />
                  </div>
                  <div className="flex justify-center mt-[44px] gap-x-[15px]">
                    <button
                      type="submit"
                      className="w-[128px] h-[40px] bg-[#FF6300] rounded-[5px] flex items-center justify-center font-semibold text-[14px] text-white"
                    >
                      Withdraw
                    </button>
                    <button
                      type="button"
                      onClick={togglePopup}
                      className="w-[110px] h-[40px] bg-white rounded-[5px] flex items-center justify-center font-semibold text-[14px] text-black border"
                    >
                      Close
                    </button>
                  </div>
                  <p className="flex justify-center font-medium text-black text-[14px] mt-[23px]">
                    Withdrawal process may take up to 24 hours.
                  </p>
                </form>
              </div>
            </div>
          )}

          <button
            className="w-[151px] h-[41px] bg-white rounded-[5px] text-black flex items-center justify-center border font-semibold text-[14px]"
            onClick={() =>
              navigate(`/SellerDashboard/paymentList/paymentSettings/${"654"}`)
            }
          >
            Payment Settings
          </button>
        </div>
      </div>
      <div className="w-full h-[110px] flex items-center justify-between mt-[27px]">
        <div className="w-[302px] h-[110px] bg-white rounded-[10px] py-[26px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <p className="w-[9px] h-[57px] bg-[#6FC33B] rounded-r-full"></p>
          <div className="flex flex-row justify-between w-full">
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[164px] h-[18px] font-semibold text-[14px] text-black text-start">
                Total Payments (in ₹)
              </h4>
              <p className="w-[105px] h-[30px] font-semibold text-[20px] text-[#FF6300] text-start">
                ₹ 5,00,000
              </p>
            </div>
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1007_17248)">
                <path
                  d="M34 16V10C34 9.46957 33.7893 8.96086 33.4142 8.58579C33.0391 8.21071 32.5304 8 32 8H12C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12M8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16H36C36.5304 16 37.0391 16.2107 37.4142 16.5858C37.7893 16.9609 38 17.4696 38 18V24M8 12V36C8 37.0609 8.42143 38.0783 9.17157 38.8284C9.92172 39.5786 10.9391 40 12 40H36C36.5304 40 37.0391 39.7893 37.4142 39.4142C37.7893 39.0391 38 38.5304 38 38V32"
                  stroke="#D9D9D9"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M40 24V32H32C30.9391 32 29.9217 31.5786 29.1716 30.8284C28.4214 30.0783 28 29.0609 28 28C28 26.9391 28.4214 25.9217 29.1716 25.1716C29.9217 24.4214 30.9391 24 32 24H40Z"
                  stroke="#D9D9D9"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1007_17248">
                  <rect width="48" height="48" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>

        <div className="w-[302px] h-[110px] bg-white rounded-[10px] py-[26px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <p className="w-[9px] h-[57px] bg-[#85B6FF] rounded-r-full"></p>
          <div className="flex flex-row justify-between w-full">
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[179px] h-[18px] font-semibold text-[14px] text-black text-start">
                Total Amount Withdrawn
              </h4>
              <p className="w-[105px] h-[30px] font-semibold text-[20px] text-[#FF6300] text-start">
                ₹ 3,00,000
              </p>
            </div>
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 24L22 28L30 20M6 24C6 26.3638 6.46558 28.7044 7.37017 30.8883C8.27475 33.0722 9.60062 35.0565 11.2721 36.7279C12.9435 38.3994 14.9278 39.7252 17.1117 40.6298C19.2956 41.5344 21.6362 42 24 42C26.3638 42 28.7044 41.5344 30.8883 40.6298C33.0722 39.7252 35.0565 38.3994 36.7279 36.7279C38.3994 35.0565 39.7252 33.0722 40.6298 30.8883C41.5344 28.7044 42 26.3638 42 24C42 21.6362 41.5344 19.2956 40.6298 17.1117C39.7252 14.9278 38.3994 12.9435 36.7279 11.2721C35.0565 9.60062 33.0722 8.27475 30.8883 7.37017C28.7044 6.46558 26.3638 6 24 6C21.6362 6 19.2956 6.46558 17.1117 7.37017C14.9278 8.27475 12.9435 9.60062 11.2721 11.2721C9.60062 12.9435 8.27475 14.9278 7.37017 17.1117C6.46558 19.2956 6 21.6362 6 24Z"
                stroke="#D9D9D9"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <div className="w-[302px] h-[110px] bg-white rounded-[10px] py-[26px] pr-[14px] flex items-start drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <p className="w-[9px] h-[57px] bg-[#FF6300] rounded-r-full"></p>
          <div className="flex flex-row justify-between w-full">
            <div className="flex flex-col h-[60px] justify-between ml-[18px]">
              <h4 className="w-[113px] h-[18px] font-semibold text-[14px] text-black text-start">
                Total Balance
              </h4>
              <p className="w-[105px] h-[30px] font-semibold text-[20px] text-[#FF6300] text-start">
                ₹ 1,50,000
              </p>
            </div>
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34 18V14C34 12.9391 33.5786 11.9217 32.8284 11.1716C32.0783 10.4214 31.0609 10 30 10H10C8.93913 10 7.92172 10.4214 7.17157 11.1716C6.42143 11.9217 6 12.9391 6 14V26C6 27.0609 6.42143 28.0783 7.17157 28.8284C7.92172 29.5786 8.93913 30 10 30H14M14 22C14 20.9391 14.4214 19.9217 15.1716 19.1716C15.9217 18.4214 16.9391 18 18 18H38C39.0609 18 40.0783 18.4214 40.8284 19.1716C41.5786 19.9217 42 20.9391 42 22V34C42 35.0609 41.5786 36.0783 40.8284 36.8284C40.0783 37.5786 39.0609 38 38 38H18C16.9391 38 15.9217 37.5786 15.1716 36.8284C14.4214 36.0783 14 35.0609 14 34V22ZM30 28C30 29.0609 30.4214 30.0783 31.1716 30.8284C31.9217 31.5786 32.9391 32 34 32C35.0609 32 36.0783 31.5786 36.8284 30.8284C37.5786 30.0783 38 29.0609 38 28C38 26.9391 37.5786 25.9217 36.8284 25.1716C36.0783 24.4214 35.0609 24 34 24C32.9391 24 31.9217 24.4214 31.1716 25.1716C30.4214 25.9217 30 26.9391 30 28Z"
                stroke="#D9D9D9"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="w-full h-[609px] mt-[31px]">
        <div className="flex">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`px-4 py-2 -mb-px border-b-2 transition-all duration-300 ${
                activeTab === index
                  ? "border-[#FF6300] text-black font-semibold text-[16px]"
                  : "border-transparent text-black font-semibold text-[16px]"
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="w-full h-auto">
          {tabContent.map((content, index) => (
            <div
              key={index}
              className={`transition-opacity duration-300 ${
                activeTab === index ? "opacity-100" : "opacity-0 absolute"
              }`}
            >
              {activeTab === index && <div>{content.panel}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
    // </div>
  );
};

export default SellerPayment;
